module.exports = __webpack_public_path__ + "static/img/0005-A-01.b193b4b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/audioimg/0005-A-01.jpg
// module id = 35tN
// module chunks = 0